/**
 * Styled native single-line input forwarding all input attributes and its element ref.
 *
 * @module apps/web/src/components/ui/input
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Native HTML input attributes accepted by the shared input.
 */
export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 * Ref-forwarding native input with shared border, focus, file-input, and disabled styles.
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
